import React from 'react';
import '../styles/MiniApp.css';

function MiniAppShell() {
  return (
    <div className="miniapp-page">
      <div className="miniapp-card">
        <h1>Добро пожаловать миниприложение KAT-Telecom</h1>
        <p className="miniapp-status">Пустой экран mini app</p>
        <div className="miniapp-user">
          <div>Функционал будет добавлен позже.</div>
        </div>
      </div>
    </div>
  );
}

export default MiniAppShell;
